import React, { useState, useRef, useCallback, useEffect } from 'react'
import Classes from './Upgrades.module.css'
import Color from 'color';
import { useSelector } from 'react-redux';
import backend from '../../../../../api';
import { motion, easeOut, AnimatePresence } from 'framer-motion';

const CheckSvg = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" /></svg>
)

export default function Upgrades() {
    let onBoarding = useSelector((state) => state.companyInfo?.info);
    onBoarding.color = '#006b32'
    const { user } = useSelector((state) => state.auth);

    const companyId = onBoarding?._id;
    const email = user?.email

  const userId = user?._id

    const convertToRgba = (colorInput, opacity) => {
        try {
            const color = Color(colorInput);
            return color.alpha(opacity).rgb().string();
        } catch (error) {
            console.error("Invalid color format:", colorInput);
            return `rgba(0, 0, 0, ${opacity})`;
        }
    };

    
    const onPaymentMonthlyBasic = async () => {
      
        const response = await backend.post(`/create-checkout-session`, {
            subscription: "monthly_basic",
            email: email,
            userId: userId
        });

        const url = response.data.url;
        window.location.href = url;
    }

      const onPaymentYearlyBasic = async () => {
      
        const response = await backend.post(`/create-checkout-session`, {
            subscription: "yearly_basic",
            email: email,
            userId: userId
        });

        const url = response.data.url;
        window.location.href = url;
    }


    return (
        <>
            <div className={Classes.hero} >
                <div className={Classes.pricingMain} >
                    <motion.div
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 10 }}
                        transition={{
                            delay: 0.3,
                            duration: 0.3,
                        }}
                        className={Classes.hide765}
                    >
                        <div className={`${Classes.pricingElem} ${Classes.padding3}`} style={{ border: 'none' }} >
                            <div className={Classes.header} >

                            </div>
                            <div className={`${Classes.listingCon}`} >
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > AI-Powered Data Tracking </h5>
                                </div>
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > Automated Data Removal </h5>
                                </div>
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > Real-Time Email Alerts </h5>
                                </div>
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > Downloadable Reports </h5>
                                </div>
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > Customizable Monitoring </h5>
                                </div>
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > Support </h5>
                                </div>
                            </div>

                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 10 }}
                        transition={{
                            delay: 0.1,
                            duration: 0.5,
                        }}
                    >
                        <div className={Classes.pricingElem} style={{ background: convertToRgba(onBoarding?.color, 0.10) }} >
                            <div className={Classes.header} >
                                <h5 className={Classes.title1} > Monthly </h5>
                                <h1 className={Classes.price} > $10 <span>/month</span> </h1>
                                <h5 className={Classes.textLightMini} > Billed monthly </h5>
                            </div>

                            <div className={`${Classes.listingCon} ${Classes.hide765}`} >
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <h5 className={Classes.text} > Basic </h5> </div>
                            </div>

                            <div className={`${Classes.listingCon} ${Classes.hideAbove765}`} >
                                <div className={Classes.flex}>
                                    <h5 className={Classes.textBold} > AI-Powered Data Tracking </h5>
                                </div>
                                <div className={Classes.flex}>
                                    <h5 className={Classes.textBold} > Automated Data Removal </h5>
                                </div>
                                <div className={Classes.flex}>
                                    <h5 className={Classes.textBold} > Real-Time Email Alerts </h5>
                                </div>
                                <div className={Classes.flex}>
                                    <h5 className={Classes.textBold} > Downloadable Reports </h5>
                                </div>
                                <div className={Classes.flex}>
                                    <h5 className={Classes.textBold} > Customizable Monitoring </h5>
                                </div>
                                <div className={Classes.flex}>
                                    <h5 className={Classes.textBold} > Basic Support </h5>
                                </div>
                            </div>

                            <div className='flex' >
                                <div className={Classes.btnCon} >
                                    <button onClick={onPaymentMonthlyBasic} className={Classes.btnHeight} style={{ background: onBoarding?.color }}
                                    > <h5>Upgrade</h5> </button>
                                </div>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 10 }}
                        transition={{
                            delay: 0.2,
                            duration: 0.6,
                        }}
                    >
                        <div className={Classes.pricingElem} >
                            <div className={Classes.header} >
                                <h5 className={Classes.title1} > Annually </h5>
                                <h1 className={Classes.price} > $100 <span>/year</span> </h1>
                                <h5 className={Classes.textLightMini} > Billed annually </h5>
                            </div>

                            <div className={`${Classes.listingCon} ${Classes.hide765}`} >
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <h5 className={Classes.text} > Advanced </h5> </div>
                            </div>

                            <div className={`${Classes.listingCon} ${Classes.hideAbove765}`} >
                                <div className={Classes.flex}>
                                    <h5 className={Classes.textBold} > AI-Powered Data Tracking </h5>
                                </div>
                                <div className={Classes.flex}>
                                    <h5 className={Classes.textBold} > Automated Data Removal </h5>
                                </div>
                                <div className={Classes.flex}>
                                    <h5 className={Classes.textBold} > Real-Time Email Alerts </h5>
                                </div>
                                <div className={Classes.flex}>
                                    <h5 className={Classes.textBold} > Downloadable Reports </h5>
                                </div>
                                <div className={Classes.flex}>
                                    <h5 className={Classes.textBold} > Customizable Monitoring </h5>
                                </div>
                                <div className={Classes.flex}>
                                    <h5 className={Classes.textBold} > Advanced Support </h5>
                                </div>
                            </div>

                            <div className='flex' >
                                <div className={Classes.btnCon} >
                                    <button onClick={onPaymentYearlyBasic} className={Classes.btnHeight} style={{ background: onBoarding?.color }}
                                    > <h5>Upgrade</h5> </button>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </>
    )
}
